<template>
  <v-container fluid>
    <v-row align="center">
      <v-col class="py-0">
        <slot name="title"></slot>
      </v-col>
      <v-col>
        <slot name="filters"></slot>
      </v-col>
      <v-col class="py-0" cols="4">
        <v-container py-0
          ><v-row justify="end">
            <v-text-field
              append-icon="mdi-magnify"
              label="Filter"
              single-line
              hide-details
              v-model="search"
              :outlined="outlinedInputs"
              dense
            ></v-text-field>
            <slot></slot></v-row
        ></v-container>
      </v-col>
    </v-row>
    <v-layout align-center justify-end> </v-layout>
    <v-layout pt-3>
      <v-flex>
        <v-card outlined>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            v-bind="pagingOptions"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td
                    :class="
                      header.type != 'actions' ? 'text-xs-left' : 'relative'
                    "
                    v-for="(header, index) in headers"
                    :key="index"
                  >
                    <template v-if="header.type == 'actions'">
                      <component
                        :is="header.actionsComponent"
                        :item="item.node"
                        @rowAction="rowActionHandler"
                      ></component>
                    </template>
                    <template v-else-if="header.type == 'checkbox'">
                      <v-checkbox
                        @click="header.handler(item)"
                        v-model="item.node[header.value]"
                      ></v-checkbox>
                    </template>
                    <template v-else>{{
                      displayItem(item.node, header)
                    }}</template>
                  </td>
                </tr>
              </tbody>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { pagingOptions } from "../../../helpers/index";
var moment = require("moment");
export default {
  name: "BasicDataTable",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: String,
      default: () => null,
    },
    sortDesc: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      pagingOptions,
      search: "",
      fab: false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    displayItem: function (item, header) {
      let value = item[header.value.split(".")[1]];
      if (header.type == "date") {
        return this.$options.filters.formatDate(value);
      } else if (header.type == "dateTime") {
        return this.$options.filters.formatDateTime(value);
      } else if (header.type == "user") {
        let userProperty = header.value.split(".")[2];
        return value[userProperty];
      } else if (header.type == "actions") {
        return "";
      } else {
        return value;
      }
    },
    rowActionHandler(event) {
      this.$emit("rowAction", { ...event });
    },
  },
};
</script>
<style scoped>
.relative {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/BasicDataTable.vue